if (!customElements.get('accordion')) {
  class accordionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setupAccordion();
    }

    setupAccordion() {
      const toggles = this.querySelectorAll('.accordion-toggle');

      toggles.forEach((toggle) => {
        toggle.addEventListener('click', function () {
          const content = this.nextElementSibling;

          // Close all other accordions
          toggles.forEach((other) => {
            if (other !== this) {
              other.classList.remove('active');
              const otherContent = other.nextElementSibling;
              if (otherContent) otherContent.style.maxHeight = null;
            }
          });

          // Toggle this one
          this.classList.toggle('active');

          if (this.classList.contains('active')) {
            content.style.maxHeight = content.scrollHeight + 'px';
          } else {
            content.style.maxHeight = null;
          }
        });
      });
    }
  }

  customElements.define('accordion-list', accordionList);
}
